'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefix;

function prefix(name) {
  try {
    if (window) {
      if (typeof window[name] !== 'undefined') {
        return window[name];
      } else {
        var prefixed = 'webkit' + name;
        return window[prefixed];
      }
    }
  } catch (err) {}
}